import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import "./Responsive.css";
import Login from "./Auth/Login";
import Invest from "./Components/Invest";
import CardSlider from "./Components/CardSlider";
import Filter from "./Components/Filter";
import ListView from "./Components/ListView";
import InvestDetails from "./Components/InvestDetails";
import CheckScam from "./Components/CheckScam";
import SideNavbar from "./Components/SideNavbar";
import NewPools from "./Components/NewPools";
import Header from "./Components/Header";
import DetailView from "./Components/DetailView";
import Home from "./Auth/Home";
// *****************Central Exchange*********************
import CentralCard from "./CenteralExchange/CentralCard";
import ActiveCoin from "./Components/ActiveCoin";
import UpcomingCoin from "./Components/UpcomingCoin";
import PrivateSale from "./Components/PrivateSale";
import DetailPS from "./Components/DetailPS";
// *********************My Fav***************************
import Favorites from "./CenteralExchange/Favorites";
import AddNew from "./CenteralExchange/AddNew";
import { ToastContainer } from "react-toastify";
import DEX from "./CenteralExchange/DEX";
import FavPrivate from "./CenteralExchange/FavPrivate";
import NewDetail from "./CenteralExchange/NewDetail";
import ConnectModal from "./Connect Wallet/ConnectModal";
import WalletDetail from "./Connect Wallet/WalletDetail";
import History from "./Connect Wallet/History";
import Cex from "./CenteralExchange/Cex";

function App() {
  const location = useLocation();

  const showSidebar = location.pathname !== "/";

  return (
    <div className="wrap-all">
      <>
        {/* ****************SideNavBar************** */}
        {showSidebar && <SideNavbar />}
        <Routes>
          <Route path="/connect-wal" element={<ConnectModal />} />
          <Route path="/wallet" element={<WalletDetail />} />
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Home />} />
          {/*****************DEX**************/}
          <Route path="/DEX" element={<Invest />} />
          <Route path="/card" element={<CardSlider />} />
          <Route path="/filter" element={<Filter />} />
          <Route path="/listView" element={<ListView />} />
          <Route path="/details/:tokenaddress" element={<InvestDetails />} />
          <Route path="/newpools" element={<NewPools />} />
          <Route path="/detail-view" element={<DetailView />} />
          {/* ***************CheckScam****************** */}
          <Route path="/check-scam" element={<CheckScam />} />
          {/* *******************CEX***************** */}
          <Route path="/exchange" element={<CentralCard />} />
          <Route path="/watch-list" element={<Favorites />} />
          {/* ****************Private Sales***************/}
          <Route path="/private-sale" element={<PrivateSale />}></Route>
          <Route path="/active-coin" element={<ActiveCoin />}></Route>
          <Route path="/upcoming-coin" element={<UpcomingCoin />}></Route>
          <Route path="/PS-detail" element={<DetailPS />} />
          <Route path="/dexxxx" element={<DEX />} />
          <Route path="/newdetail/:tokenaddress" element={<NewDetail />} />
          <Route path="/history" element={<History/>}/>
          <Route path="/CEX" element={<Cex/>}/>

        </Routes>
        <ToastContainer />
      </>
    </div>
  );
}

export default App;
